import React from 'react'
import MediaQuery from 'react-responsive'

import {
  RemoteSignaturePadErrorProps,
  RemoteSignaturePadProps,
  SignaturePad,
  SignaturePadProps,
  withRemoteSignaturePad,
  withSignaturePad,
} from '@acorns/signature-pad'
import { ConfirmationModal, ConfirmationModalProps, ModalActionTypes } from '@acorns/web-components'
import { compose, withHandlers, withProps } from 'recompose'

import { style } from 'theme'
import Environment, { withEnv } from 'utils/environment'

import { HelperText, PhoneContainer, SignaturePhoneContainer } from './styled-components'

type Props = {
  errorTitle: string
  errorMessage: string
  env: Environment
  onRequestClose: () => void
}

type MergedProps = Props &
  RemoteSignaturePadProps &
  RemoteSignaturePadErrorProps &
  ConfirmationModalProps &
  SignaturePadProps

const enhance = compose<MergedProps, MergedProps>(
  withEnv,
  withSignaturePad(({ env }) => ({
    signatureServiceUrl: env.get('signatureService'),
  })),
  withRemoteSignaturePad(({ env }) => ({
    signatureServiceUrl: env.get('signatureService'),
  })),
  withHandlers({
    onRequestClose: () => () => {
      window.location.reload(true)
    },
  }),
  withProps(({ showError, onRequestClose }) => {
    if (showError) {
      return {
        actions: [
          {
            label: 'Refresh page',
            handler: onRequestClose,
            type: ModalActionTypes.primary,
          },
        ],
        errorMessage:
          "We're having trouble connecting to your phone. Mind tapping refresh and trying again?",
        errorTitle: 'Whoops',
      }
    }
  }),
)

const SignaturePhone: React.ComponentClass<MergedProps> = enhance(
  ({
    connected,
    showError,
    setRemoteSignaturePad,
    handleRemoteChange,
    handleRemoteClear,
    actions,
    errorTitle,
    errorMessage,
    onRequestClose,
  }) => (
    <>
      <PhoneContainer>
        <SignaturePhoneContainer>
          <SignaturePad
            onRendered={setRemoteSignaturePad}
            loadingMessage={connected ? null : 'Connecting...'}
            onChange={handleRemoteChange}
            onClear={handleRemoteClear}
            overlayMessage="Use your finger to sign here, then complete card order on your desktop."
            showClear={true}
          />
        </SignaturePhoneContainer>
        <MediaQuery query={`(max-width: ${style(theme => theme.breakpoints.sm)}px)`}>
          <HelperText>You can rotate your phone for more space.</HelperText>
        </MediaQuery>
        <MediaQuery query={`(min-width: ${style(theme => theme.breakpoints.sm)}px)`}>
          <HelperText>
            Use your finger to sign here, then complete card order on your desktop.
          </HelperText>
        </MediaQuery>
      </PhoneContainer>
      {
        <ConfirmationModal
          onRequestClose={onRequestClose}
          isOpen={showError}
          actions={actions}
          title={errorTitle}
          message={errorMessage}
        />
      }
    </>
  ),
)

export default SignaturePhone
